import React, { useContext } from 'react'
import { Grid, CircularProgress } from '@material-ui/core'
import Post from './Post/Post'
import { ResourceContext } from '../../context/resourceContext/ResourceContext'
// import { Table } from 'reactstrap';

const PostsByCate = (data) => {
  const {
    resourceState: { resources, resourcesSearch, resourcesLoading }
  } = useContext(ResourceContext)
  if (!resources && resourcesLoading) return 'No Resources'
  return resourcesLoading ? (
    <CircularProgress />
  ) : (
    <Grid className='container' container alignItems='stretch' spacing={3}>
      {resourcesSearch && resourcesSearch.length > 0
        ? resourcesSearch.map((post) => (
            <Grid key={post._id} item xs={6} md={3}>
              <Post post={post} />
            </Grid>
          ))
        : resources.map((post) => (
            <Grid key={post._id} item xs={6} md={3}>
              <Post post={post} />
            </Grid>
          ))}
      {resources.length > 0 ? (
        ''
      ) : (
        <p style={{ flexBasis: '100%', padding: '0px 20px', fontSize: '20px' }}>
          No files have been uploaded yet
        </p>
      )}
    </Grid>
  )
}

export default PostsByCate
